export function parseFeedbackData(data, permissions) {
  return {
    feedback: {
      files: data.file_objs?.map(file => ({ ...file, name: file.filename })),
      permissions: { ...data.permissions, ...permissions },
      text: data.text,
      uuid: data.uuid,
    },
  }
}
